/* eslint-disable react/prop-types */
import { Checkbox, Tooltip } from "@mui/material";

import React, { useState } from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import LowPriorityIcon from "@mui/icons-material/LowPriority";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";

import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import AllInboxIcon from "@mui/icons-material/AllInbox";
import Swal from "sweetalert2";
import { useMaterialUIController } from "context";
import getText from "Translator";
import { displaySuccessMessage } from "controllers/validation";
import { displayErrorMessage } from "controllers/validation";
import { useNavigate } from "react-router-dom";
import { deleteQuestion } from "controllers/QuestionController";
import CallMissedOutgoingIcon from "@mui/icons-material/CallMissedOutgoing";
import { updateQuestionAllowCopy } from "controllers/QuestionController";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
let mode = "subform";
function MenuComponent(props) {
  const [controller] = useMaterialUIController();

  const [openCondition, setOpenCondition] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    id,
    headline,
    title,
    capsule,
    form,
    page,
    question,
    getQuestions,
    handleOpenCondition,
    editQuestionHandle,
    copyListHandler,
  } = props;
  const [allowCopy, setAllowCopy] = useState(question.allowCopy);
  const handleCloseCondition = () => {
    setOpenCondition(false);
  };
  const navigate = useNavigate();
  //   const handleOpenCondition = () => {
  //     setOpenCondition(true);
  //   };

  const handleDeleteClick = (id) => {
    try {
      if (!controller.authenticated) {
        navigate("/", { replace: true });
        return;
      }
      Swal.fire({
        text: getText("deleteconfirm", controller.lang),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: getText("confirmButtonText", controller.lang),
        cancelButtonText: getText("cancel", controller.lang),
      }).then(async (result) => {
        if (result.value) {
          setLoading(true);
          let data = await deleteQuestion(
            controller.lang,
            { id },
            controller.token
          );
          if (data.success) {
            getQuestions();
            displaySuccessMessage(
              controller.lang,
              getText("deletesuccessful", controller.lang)
            );
          } else {
            displayErrorMessage(controller.lang, data.message);
          }

          if (data.errorCode === 101) {
            navigate("/", { replace: true });
          }

          setLoading(false);
        }
      });
    } catch (err) {
      displayErrorMessage(controller.lang);
    }
  };

  return (
    <div
      style={{ textAlign: controller.direction == "rtl" ? "left" : "right" }}
    >
      <Tooltip
        title={getText("delete", controller.lang)}
        aria-label="delete"
        style={{
          paddingRight: 5,
          paddingLeft: 5,
          cursor: "pointer",
          fontSize: 18,
        }}
      >
        <HighlightOffIcon
          style={{ width: 22 }}
          color="secondary"
          onClick={() => {
            handleDeleteClick(question._id);
          }}
        />
      </Tooltip>
      <Tooltip
        title={getText("edit", controller.lang)}
        aria-label="edit"
        style={{
          paddingRight: 5,
          paddingLeft: 5,
          cursor: "pointer",
          fontSize: 18,
        }}
      >
        <ModeEditOutlineOutlinedIcon
          style={{ width: 22 }}
          color="secondary"
          onClick={async () => {
            editQuestionHandle(question);
          }}
        />
      </Tooltip>

      {/* <Tooltip
        title={getText("condition", controller.lang)}
        aria-label="Condition"
        style={{
          paddingRight: 5,
          paddingLeft: 5,
          cursor: "pointer",
          fontSize: 18,
        }}
      >
        <LowPriorityIcon
          style={{ width: 22 }}
          color="secondary"
          onClick={() => {
            mode = "subform";
            handleOpenCondition();
          }}
        />
      </Tooltip> */}

      {question.question.questionType === "CALC" && (
        <Tooltip
          title={getText("quescondition", controller.lang)}
          aria-label="question"
          style={{
            paddingRight: 5,
            paddingLeft: 5,
            cursor: "pointer",
            fontSize: 18,
          }}
        >
          <AllInclusiveIcon
            style={{ width: 22 }}
            color="secondary"
            onClick={() => {
              handleOpenCondition("question", question.question._id);
            }}
          />
        </Tooltip>
      )}
     <Tooltip
        aria-label="visibilityx"
        style={{
          paddingRight: 5,
          paddingLeft: 5,
          cursor: "pointer",
          fontSize: 18,
        }}
      >
        <>
          {!question.visibleCondition && (
            <VisibilityIcon
              color="secondary"
              style={{
                cursor: "pointer",
                fontSize: 24,
                width: 22,
                marginTop: 5,
              }}
              onClick={() => {
                navigate(
                  `/condition/${headline}/${title}/${capsule}/${form}/${page}/visible/formType/${question._id}`
                );
              }}
            />
          )}
          {question.visibleCondition && (
            <VisibilityOffIcon
              color="primary"
              style={{
                cursor: "pointer",
                fontSize: 24,
                width: 22,
                marginTop: 5,
              }}
               onClick={() => {
                navigate(
                  `/condition/${headline}/${title}/${capsule}/${form}/${page}/visible/formType/${question._id}`
                );
              }}
            />
          )}
        </>
      </Tooltip>
     {/*   <Tooltip
        title={getText("allowcopy", controller.lang)}
        aria-label="qcondition"
        style={{
          paddingRight: 5,
          paddingLeft: 5,
          cursor: "pointer",
          fontSize: 18,
        }}
      >
        <Checkbox
          style={{ padding: 0, marginTop: -10 }}
          color="secondary"
          size="small"
          checked={question.question.allowCopy}
          onChange={async () => {
            console.log(question);
            let data = {
              question: question.question._id,
              allowCopy: !question.question.allowCopy,
            };
            let ress = await updateQuestionAllowCopy(
              controller.lang,
              data,
              controller.token
            );
            if (ress.success) {
              getQuestions();
              Swal.fire({
                text: ress.message,
                icon: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: getText("ok", controller.lang),
              });
            } else {
              Swal.fire({
                text: ress.message,
                icon: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: getText("ok", controller.lang),
              });
            }
          }}
          name="chbCanRegister"
        />
      </Tooltip> */}
      {copyListHandler && (
        <Tooltip
          title={getText("questionfromlist", controller.lang)}
          aria-label="addquestion"
          style={{
            paddingRight: 5,
            paddingLeft: 5,
            cursor: "pointer",
            fontSize: 18,
          }}
        >
          <AllInboxIcon
            style={{
              cursor: "pointer",
              float: "right",
              fontSize: 24,
              width: 22,
              marginTop: 5,
            }}
            onClick={() => copyListHandler(question)}
          />
        </Tooltip>
      )}
    </div>
  );
}
export default MenuComponent;
